<svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1712_22380)">
<path d="M41.4258 15H24.1667C22.7081 15 21.3091 15.5795 20.2777 16.6109C19.2462 17.6424 18.6667 19.0413 18.6667 20.5V59H55.3334V28.9077L41.4258 15ZM42.5001 21.259L49.0744 27.8333H42.5001V21.259ZM22.3334 55.3333V20.5C22.3334 20.0138 22.5266 19.5475 22.8704 19.2036C23.2142 18.8598 23.6805 18.6667 24.1667 18.6667H38.8334V31.5H51.6668V55.3333H22.3334Z" fill="#333333"/>
</g>
<rect x="38" y="39.0741" width="26" height="25.8518" rx="12.9259" fill="#FFE4E9"/>
<g clip-path="url(#clip1_1712_22380)">
<path d="M47.7143 50.783H48.85V54.3545C48.85 54.7473 49.1714 55.0687 49.5643 55.0687H52.4214C52.8143 55.0687 53.1357 54.7473 53.1357 54.3545V50.783H54.2714C54.9071 50.783 55.2286 50.0116 54.7786 49.5616L51.5 46.283C51.2214 46.0045 50.7714 46.0045 50.4929 46.283L47.2143 49.5616C46.7643 50.0116 47.0786 50.783 47.7143 50.783ZM46 57.2116C46 57.6045 46.3214 57.9259 46.7143 57.9259H55.2857C55.6786 57.9259 56 57.6045 56 57.2116C56 56.8187 55.6786 56.4973 55.2857 56.4973H46.7143C46.3214 56.4973 46 56.8187 46 57.2116Z" fill="#93182F"/>
</g>
<defs>
<clipPath id="clip0_1712_22380">
<rect width="44" height="44" fill="white" transform="translate(15 15)"/>
</clipPath>
<clipPath id="clip1_1712_22380">
<rect width="10" height="11.8518" fill="white" transform="translate(46 46.0741)"/>
</clipPath>
</defs>
</svg>
